import './FrameworkSearchForm.css';

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Search } from '@mui/icons-material';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { generateClassName, generateSelectField, generateTextField, handleObjectFieldChange } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';
import { fetchGenericFrameworksB2BIndicatorsData } from '../../../services/b2b-frameworks-apiService';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const FrameworkSearchForm = ({ frameworkSuite, title, framework = null,
    currentPage, setCurrentPage, refresh, setRefresh, isSearching, setIsSearching,
    setIndicatorsData, setPagesCount, className = null }) => {

    const { t } = useB2BTranslation('b2b-plans');
    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);
    const [searchFields, setSearchFields] = useState({
        topLevelId: '',
        indicatorType: '',
        indicatorNature: '',
        dataEntry: '',
    });

    const getIndicatorsData = useCallback(async () => {
        try {
            if (loginData && currentPage > 0 && refresh && !isSearching) {
                setIsSearching(true);
                const { accessToken, loggedOrganizationUuid } = loginData;
                const data = await fetchGenericFrameworksB2BIndicatorsData(frameworkSuite, currentPage - 1, 12, framework.frameworkId, searchFields, accessToken, loggedOrganizationUuid, true, true);
                setIndicatorsData(data);
                setPagesCount(data.totalPages);
                setRefresh(false);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsSearching(false);
            setRefresh(false);
        }
    }, [loginData, refresh, currentPage]);

    useEffect(() => {
        if (currentPage !== 0) {
            getIndicatorsData();
        }
    }, [currentPage, refresh, getIndicatorsData]);

    // useEffect(() => {
    //     setRefresh(true);
    // }, [currentPage]);

    const onSearch = async () => {
        setCurrentPage(1);
        setRefresh(true);
    }

    const buttonsConfig = [
        {
            label: t('Search'),
            disabledText: t('Search'),
            onClick: onSearch,
            isLoading: isSearching,
            color: 'secondary',
            variant: 'contained',
            key: '1',
            icon: <Search />,
        },
    ];

    const level1Options = framework && framework.subLevels
        ? framework.subLevels.map(subLevel => ({
            value: subLevel.levelN_ItemId,
            label: `${subLevel.levelN_ItemStrId} - ${subLevel.levelN_ItemName}`,
        }))
        : [];
    level1Options.unshift({ value: '', label: 'All', default: true });
    const level1 = framework.levelDefinitions.find(fw => fw.fwLevelId === 1);

    const indicatorTypes = [
        {
            value: '',
            label: t('All'),
            default: true,
        },
        {
            value: 'QUANTITATIVE',
            label: t('Quantitative'),
        },
        {
            value: 'QUALITATIVE',
            label: t('Qualitative'),
        },
        {
            value: 'QUANTITATIVE_DIMENSIONAL',
            label: t('Dimensional'),
        },
    ];

    const indicatorNature = [
        {
            value: '',
            label: t('All'),
            default: true,
        },
        {
            value: 'PRODUCT',
            label: t('Platform'),
        },
        {
            value: 'ORGANIZATION',
            label: t('Custom'),
        },
    ];

    const dataEntry = [
        {
            value: '',
            label: t('All'),
            default: true,
        },
        {
            value: 'MANUAL',
            label: t('Manual'),
        },
        {
            value: 'AUTO',
            label: t('Automatic'),
        },
    ];

    return (
        <B2BFormContainer title={title ? title : t('Search form')} className={generateClassName("framework-search-form", "", className)} orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
            {generateSelectField(level1Options,
                {
                    label: level1 ? level1.fwLevelName : t('Level 1'),
                    value: searchFields.topLevelId,
                    onChange: (e) => handleObjectFieldChange('topLevelId', e.target.value, setSearchFields),
                    className: generateClassName("framework-search-form", "-search-select-field-level1", className),
                })}
            {generateSelectField(indicatorTypes,
                {
                    label: t('Indicator type'),
                    value: searchFields.indicatorType,
                    onChange: (e) => handleObjectFieldChange('indicatorType', e.target.value, setSearchFields),
                    className: generateClassName("framework-search-form", "-search-select-field", className),
                })}
            {generateSelectField(indicatorNature,
                {
                    label: t('Indicator nature'),
                    value: searchFields.indicatorNature,
                    onChange: (e) => handleObjectFieldChange('indicatorNature', e.target.value, setSearchFields),
                    className: generateClassName("framework-search-form", "-search-select-field", className),
                })}
            {generateSelectField(dataEntry,
                {
                    label: t('Data entry'),
                    value: searchFields.dataEntry,
                    onChange: (e) => handleObjectFieldChange('dataEntry', e.target.value, setSearchFields),
                    className: generateClassName("framework-search-form", "-search-select-field", className),
                })}
        </B2BFormContainer >
    );
}

export default FrameworkSearchForm;